import React from 'react';

import {CircularProgress, Backdrop} from '@ui';
import {setModal, setModalConfirmation, setModalError} from '@actions';

import configuredStore from '../store';

const setModalHandler = (data) => {
    configuredStore.dispatch(
        function (dispatch) {
            dispatch(setModal(data));
        }
    );
};

export const setErrorModal = (data) => {
    configuredStore.dispatch(
        function (dispatch) {
            dispatch(setModalError(data));
        }
    );
};

export const showErrorModal = (data) => {
    setModalHandler({size: 'tiny', ...data, isVisible: true, type: 'error'});
};

export const showDarkLoadingModal = (loaderText) => {
    setModalHandler({
        className: 'darkLoadingModal',
        content: (
            <div className='darkLoadingModal__content'>
                <CircularProgress size='large' />
                {loaderText}
            </div>
        ),
        isVisible: true,
        dimmer: {className: '--dark-background-color modal--no-transition'},
    });
};

export const hideModal = () => {
    setModalHandler({
        isVisible: false,
    });
};

export const showModal = (data) => {
    setModalHandler(data);
};

export const showModalConfirmation = (data) => {
    configuredStore.dispatch(
        function (dispatch) {
            dispatch(setModalConfirmation(data));
        }
    );
};

const getModalLoadingContent = () => (
    <div className="content">
        <Backdrop open inverted>
            <CircularProgress />
        </Backdrop>
    </div>
);

export const showLoadingModal = (params = {}) => {
    configuredStore.dispatch(
        function (dispatch) {
            dispatch(setModal({
                content: getModalLoadingContent(),
                isVisible: true,
                size: params.size || 'large',
            }));
        }
    );
};
